import { createReducer } from '@reduxjs/toolkit'
import * as actions from '../../actions/TestEnvironment/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type TestEnvironmentStore = {
  variant: actions.TestEnvironmentVariant
  isInitialized: boolean
}

const INITIAL_STATE: TestEnvironmentStore = {
  variant: 'prod',
  isInitialized: false
}

const TestEnvironmentReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.initialize, (state, action) => {
      state.variant = action.payload.variant
      state.isInitialized = true
    })
    .addCase(actions.update, (state, action) => {
      state.variant = action.payload.variant
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default TestEnvironmentReducer
